// -----------------------------
// helpers
// -----------------------------
function isPlzInput(el) {
  const result = !!(el && el.id && el.id.startsWith('plz-input'));
  return result;
}

// Zentrale Registry für PLZ-Handler
const plzHandlers = {
  input: [],
  keydown: [],
};

// -----------------------------
// isolate from global scripts
// -----------------------------
// Capture auf document – läuft als erstes
['input', 'focusin', 'keydown', 'keyup'].forEach(eventType => {
  document.addEventListener(eventType, function (e) {
    if (!isPlzInput(e.target)) return;

    e.stopImmediatePropagation(); // fremde Handler blockieren

    // Eigene Handler direkt aufrufen
    if (plzHandlers[eventType]) {
      plzHandlers[eventType].forEach(fn => fn(e));
    }
  }, true);
});

// optional: block forced blur
const originalBlur = HTMLInputElement.prototype.blur;
HTMLInputElement.prototype.blur = function () {
  if (isPlzInput(this)) {
    return;
  }
  return originalBlur.apply(this, arguments);
};


// -----------------------------
// main init
// -----------------------------
function initPlzCheck(section) {

  if (!section) {
    return;
  }

  const input = section.querySelector('input[id^="plz-input"]');
  const feedback = section.querySelector('.plz-check__feedback');


  if (!input || input._plzInitialized) {
    return;
  }

  input._plzInitialized = true;

  const allowedPLZ = new Set([
    "80331","80333","80335","80336","80337","80339","80469","80538","80539",
    "80634","80636","80637","80638","80639","80686","80687","80689",
    "80796","80797","80798","80799",
    "80801","80802","80803","80804","80805","80807","80809",
    "80933","80935","80937","80939","80992","80993","80995","80997","80999",
    "81241","81243","81245","81247","81249",
    "81369","81371","81373","81375","81377","81379",
    "81475","81476","81477","81479",
    "81539","81541","81543","81545","81547","81549",
    "81667","81669","81671","81673","81675","81677","81679",
    "81735","81737","81739",
    "81825","81827","81829",
    "81925","81927","81929"
  ]);

  // -----------------------------
  // validate
  // -----------------------------
  function validate(value, trigger) {

    if (value.length === 0) {
      feedback.textContent = '';
      feedback.className = 'plz-check__feedback';
      input.setAttribute('aria-invalid', 'false');
      return;
    }

    if (value.length < 5) {
      if (trigger === 'explicit') {
        feedback.textContent = 'Bitte geben Sie eine gültige 5-stellige Postleitzahl ein.';
        feedback.className = 'plz-check__feedback error';
        input.setAttribute('aria-invalid', 'true');
      } else {
        feedback.textContent = '';
        feedback.className = 'plz-check__feedback';
        input.setAttribute('aria-invalid', 'false');
      }
      return;
    }

    if (!/^\d{5}$/.test(value)) {
      feedback.textContent = 'Bitte geben Sie eine gültige 5-stellige Postleitzahl ein.';
      feedback.className = 'plz-check__feedback error';
      input.setAttribute('aria-invalid', 'true');
      return;
    }

    if (allowedPLZ.has(value)) {
      feedback.textContent = 'Gute Nachrichten: Ihre Postleitzahl liegt in unserem Liefergebiet.';
      feedback.className = 'plz-check__feedback success';
      input.setAttribute('aria-invalid', 'false');
    } else {
      feedback.innerHTML = `
        Leider liegt Ihre Postleitzahl außerhalb unseres Liefergebiets.<br>
        Kontaktieren Sie uns unter:
        <a href="mailto:feinkostcatering@feinkost-kaefer.de">
          feinkostcatering@feinkost-kaefer.de
        </a>
      `;
      feedback.className = 'plz-check__feedback error';
      input.setAttribute('aria-invalid', 'true');
    }
  }

  // -----------------------------
  // Handler in globale Registry eintragen
  // -----------------------------
  plzHandlers.input.push(function (e) {
    if (e.target !== input) return; // nur für diesen Input
    const raw = e.target.value;
    const clean = raw.replace(/\D/g, '');

    if (raw !== clean) {
      e.target.value = clean;
    }

    if (clean.length === 5) {
      validate(clean, 'auto');
    } else {
      validate(clean, 'typing');
    }
  });

  plzHandlers.keydown.push(function (e) {
    if (e.target !== input) return;

    if (e.key === 'Enter' || e.key === 'Tab') {
      const clean = input.value.replace(/\D/g, '');
      validate(clean, 'explicit');
      if (e.key === 'Enter') e.preventDefault();
    }
  });

}


// -----------------------------
// init lifecycle
// -----------------------------
function initAll() {
  const sections = document.querySelectorAll('.plz-check');
  sections.forEach(initPlzCheck);
}

document.addEventListener('DOMContentLoaded', function () {
  initAll();
});

document.addEventListener('shopify:section:load', function (e) {
  initPlzCheck(e.target);
});

// MutationObserver: sortButton focus-patch
const observer = new MutationObserver((mutations) => {
  const btn = document.getElementById('sortButton');
  if (btn && !btn._patched) {
    btn._patched = true;
    btn.addEventListener('focus', (e) => {
      e.target.blur();
    });
  }
});

observer.observe(document.body, { childList: true, subtree: true });